<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>出库审核</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.outStockNo" placeholder="出货单号" class="handle-input mr10" style="width:160px;"></el-input>
				<el-select v-model="query.orderCompanyId" placeholder="请选择客户" filterable>
					<el-option key="" label="请选择客户" value=""></el-option>
					<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.expressId" placeholder="送达方式" style="width:160px;">
					<el-option key="" label="请选择送达方式" value=""></el-option>
					<el-option v-for="item in expressKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.expressNo" placeholder="快递单号" class="handle-input mr10" style="width:160px;"></el-input>
				<el-input v-model="query.tel" placeholder="收件人手机号" class="handle-input mr10" style="width:160px;"></el-input>
				<el-select v-model="query.storekeeperId" placeholder="请选择仓管人员" style="width:160px;">
					<el-option key="" label="请选择仓管人员" value=""></el-option>
					<el-option v-for="item in storeUserKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="outStockNo" label="出货单号" width = "150px"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户"></el-table-column>
                <el-table-column prop="expressNo" label="快递单号"  width = "135px"></el-table-column>
				<el-table-column prop="addressee" label="收件人" width = "150px"></el-table-column>
				<el-table-column prop="tel" label="手机号" width = "120px"></el-table-column>
				<el-table-column prop="reviewerName" label="复核人" width = "120px"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="230" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-check"
                            class="red"
                            @click="handleCheck(scope.$index, scope.row)"
							v-if = "controll['check'] && scope.row.reviewerId === 0"
                        >复核</el-button>
						<el-button
                            type="text"
                            icon="el-icon-close"
                            class="red"
                            @click="handleUncheck(scope.$index, scope.row)"
							v-if = "controll['uncheck'] && scope.row.reviewerId > 0 && scope.row.storekeeperId === 0"
                        >取消复核</el-button>
						<el-button
                            type="text"
                            icon="el-icon-sold-out"
                            class="warning"
                            @click="handleCheckOut(scope.$index, scope.row)"
							v-if = "controll['check-out'] && scope.row.reviewerId > 0 && scope.row.storekeeperId === 0"
                        >确认出货</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<!-- 出库单详情 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="出库单详情" :visible.sync="showVisible" width="70%">
            <el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							出库单号
						</template>
						{{show.outStockNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							客户
						</template>
						{{show.orderCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							送达方式
						</template>
						{{expressFormat('', '', show.expressId)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							单号
						</template>
						{{show.expressNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							收货人
						</template>
						{{show.addressee}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							联系电话
						</template>
						{{show.tel}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							收货地址
						</template>
						{{show.address}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{show.storekeeperId > 0 ? "已出货" : (show.reviewerId > 0 ? "已复核":"待复核")}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							复核人
						</template>
						{{show.reviewerName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							复核时间
						</template>
						{{show.reviewerId > 0 ?  show.reviewerCheckTime : ""}}
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.storekeeperId > 0">
						<template slot="label">
							仓管员
						</template>
						{{show.storekeeperName}}
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.storekeeperId > 0">
						<template slot="label">
							出货时间
						</template>
						{{show.storekeeperCheckTime}}
					</el-descriptions-item>
				</el-descriptions>
            </el-form>
			<el-table
                :data="outStockDetail"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				style="margin-top:20px;"
				stripe
            >
				<el-table-column prop="id" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column prop="seriesName" label="名称" width = "220px"></el-table-column>
                <el-table-column prop="productName" label="型号"  width = "150px"></el-table-column>
				<el-table-column prop="outStockNum" label="出库数量"></el-table-column>
				<el-table-column prop="unit" label="单位" width = "50px"></el-table-column>
				<el-table-column prop="price" label="价格" width = "80px"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
				<el-table-column prop="amount" label="金额" width = "80px"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="stockId" label="库存编号" width = "80px"><template slot-scope="scope">{{scope.row.stockId}}号</template></el-table-column>
				<el-table-column prop="remark" label="备注" width = "160px"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchOutStockData, getAllCustomerKV, outStockCheck, outStockUnCheck, getOutStock, getEnumValueKV, getOutStockDetail, outStockStorekeeperCheck, getStoreUser } from '../../../api/index';
export default {
    name: 'out-stock-check',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			outStockDetail: [],
			showVisible: false,
            pageTotal: 0,
			show:{},
            idx: -1,
            id: -1,
			expressCode:1011,
			cityKV:{},
			companyTypeKV:{},
			sourceKV:{},
			customersKV:[],
			title:"",
			rules: {
                orderCompanyName: [{ required: true, message: '客户名称不能为空', trigger: 'blur' }],
                expressId: [{ required: true, message: '请选择送达方式', trigger: 'blur' }]
            },
			expressKV:[],
			isDisabled:false,
			storeUserKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("out-stock-check");
		this.getExpress();
		this.getStoreUsers();		
		this.getCustomers();
        this.getData();
    },
    methods: {	
		//送达方式格式化
		expressFormat(row, column, cellValue){
			if (typeof(cellValue) === "undefined") {
				return;
			}
			let index = this.expressKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.expressKV[index].value;
		},
		//获取产品信息
		getExpress() {
			getEnumValueKV(this.expressCode).then(res => {
				if (res.code == 0) {
					this.expressKV = res.data;
				} else {
					this.$message.error(`获取单位信息失败！` + res.message);
				}
			})
		},
		getStoreUsers() {
			getStoreUser().then(res => {
				if (res.code == 0) {
					this.storeUserKV = res.data;
				} else {
					this.$message.error(`获取仓库人员信息失败！` + res.message);
				}
			})
		},
		//获取客户
		getCustomers() {
			getAllCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchOutStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 审核
        handleCheck(index, row) {
            this.$confirm('确定复核出库单号为' + row.outStockNo + '的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					outStockCheck(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('复核成功');
							this.getData();
						} else {
							this.$message.error(`复核失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		// 取消审核
        handleUncheck(index, row) {
            this.$confirm('确定取消复核出库单号为' + row.outStockNo + '的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					outStockUnCheck(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('取消复核成功');
							this.getData();
						} else {
							this.$message.error(`取消复核失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		handleShow(index, row) {
			this.show = row;
			getOutStockDetail(row.id).then(res => {
				if (res.code == 0) {
					this.outStockDetail = res.data.details;
					this.$set(this.show, "imgs", res.data.imgs);
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		handleCheckOut(index, row) {
			this.$confirm('确定出库单号为' + row.outStockNo + '出货吗？，请知悉核对出库单号！', '提示', {
                type: 'warning'
            })
                .then(() => {
					outStockStorekeeperCheck(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('确认出货成功');
							this.getData();
						} else {
							this.$message.error(`确认出货失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.warning {
    color: #ffaa00;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
